import * as types from '../actionTypes/index';

export const setHelpLeadBucket = (value) => async dispatch => {
    dispatch({ type: types.SET_HELP_LEAD_BUCKET, payload: value });
}
